module.exports = __webpack_public_path__ + "static/23-6eeabbc56f63232fc3c742e4132217a0.jpg";